import { withJsonFormsControlProps } from "@jsonforms/react";
import { useEffect } from "react";
import TextInputField from "./TextInputField";

const TextInputComponent = (props) => {
  const {
    handleChange,
    label,
    data,
    path,
    errors,
    schema,
    uischema,
    required,
    enabled,
    visible,
  } = props;

  useEffect(() => {
    // Only clear data in read mode if preserveInReadMode is not set for input fields in array.
    // Example use case: [ { "answer": "Doritos", "question": "What's you favourite product"},{"answer": "Pepsi", "question": "What's you favourite drink"}]

    if (!enabled && data && !uischema.options?.preserveInReadMode) {
      handleChange(path, "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);

  const updateValue = (newVal) => {
    // For number/integer fields, convert empty string to undefined to skip validation
    if ((schema.type === "number" || schema.type === "integer") && newVal === "") {
      newVal = undefined;
    }
    const arrayValue = newVal?.length ? [newVal] : [];
    handleChange(path, schema.type === "array" ? arrayValue : newVal);
  };

  return (
    <TextInputField
      value={schema.type === "array" ? data?.[0] : data}
      disabled={!enabled}
      label={uischema.showLabel === false ? "" : label}
      updateValue={updateValue}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
      visible={visible}
    />
  );
};

export const TextInputControl = withJsonFormsControlProps(TextInputComponent);
